import {
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Button,
  useTheme,
} from "@mui/material";
import router from "next/router";
import { useTranslation } from "react-i18next";
import NextLink from "../../components/others/NextLink";
import { GetAllPostsQuery } from "../../lib/graphql/codegen/generated-client-wp";
import { formatExcerpt } from "../../utils/formatExcerpt";

const PostPreview = ({
  node,
}: {
  node: NonNullable<GetAllPostsQuery["posts"]>["edges"][number]["node"];
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const featuredImage = node.featuredImage?.node;
  return (
    <Box key={node.id}>
      <Card sx={{ maxWidth: 345 }}>
        {featuredImage?.sourceUrl && (
          <CardMedia
            component="img"
            height="140"
            src={featuredImage.sourceUrl}
            alt={featuredImage.altText ?? ""}
          />
        )}
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {node.title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            dangerouslySetInnerHTML={{
              __html: formatExcerpt(node.excerpt) ?? "",
            }}
          />
        </CardContent>
        <CardActions>
          <NextLink href={`/blog/${node.slug}`} style={{ flex: 1 }}>
            <Typography
              variant="h6"
              align="center"
              color={theme.palette.primary.main}
            >
              {t("post_preview.discover")}
            </Typography>
          </NextLink>
          {/* <Button
            size="small"
            onClick={() => router.push(`/blog/${node.slug}`)}
          >
            {t("post_preview.discover")}
          </Button> */}
        </CardActions>
      </Card>
    </Box>
  );
};

export default PostPreview;
